/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import {
    makeStyles,
    Theme,
    createStyles,
    Grid,
    TextField,
    Divider,
    Typography,
    FormControl,
    FormLabel,
    FormControlLabel,
    Checkbox,
    IconButton
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import AttachmentsField, { AttachedFile } from '../../components/AttachmentsField';
import { useSaveInFlight } from './useSaveInFlight';
import { SendEmailFile, dropDuplicateAttachments, getFilesToSend, toAttachedFile, validateAttachedFiles } from './emailAttachments';
import { SkeletonLoader } from '../../components/loading/SkeletonLoader';
import { mainTheme } from '../../Theme';
import { Field, FieldInputProps, Form, FormSpy } from 'react-final-form';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { showNotification } from '../../App';
import { client } from '../..';
import { FormApi } from 'final-form';
// import DialogBox from '../../Dashboard/Component/DialogBox';
import { FollowUp } from './FollowUpDialog';
import { EnquiryDefaultConfig, FollowUpEnquiryMutation } from '../EnquirySummaryRepository';
import moment from 'moment';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { FetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { EmailTemplateMessageTypeEnum, EmailTemplateTypeEnum } from '../../emailTemplatesConfiguration/EmailTemplateRespository';
import { OutcomeSegmentedControl } from '../radio/OutcomeSegmentedControl';
import { ConnectedCannedNotesForField } from '../drawers/components/useCannedNotes';
import clsx from 'clsx';
import { KeyboardDateTimePicker } from '@material-ui/pickers/DateTimePicker/DateTimePicker';
import { MentionItem } from 'react-mentions';
import { ReasonSelector } from '../selectors/ReasonSelector';
// import { Editor } from '@tinymce/tinymce-react';
import { addBusinessDays } from '../drawers/EnquiryFormDrawer';
import { EditorWrapper } from '../../components/Editor';
import { ReminderSelector } from '../../components/ReminderSelector';
import { DocumentFile } from '../../types/DocumentFile';
import { useApplicationSettings } from '../../applicationSettings/ApplicationSettingsRepository';
import { SpeechTextFieldWithMarkup } from '../../components/SpeechTextFieldWithMarkup';
import { LightTooltip } from '../../helpers/commonHelper';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { EmailResponseTemplateSelector } from '../../emailTemplatesConfiguration/selectors/EmailResponseTemplateSelector';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        // the white sits on the input itself, not the whole field, so a helper/error message below it stays on the card's own background
        textField: {
            width: '100%',
            '& .MuiInputBase-root': {
                backgroundColor: '#fff',
            },
        },
        commendField: {
            width: '100%',
        },
        dialogTitle: {
            color: mainTheme.TemplateColor.Primary,
        },
        dropzone: {
            paddingTop: 10,
            paddingBottom: 10,
        },
        matterLabel: {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
        },
        hideDate: {
            display: 'none'
        },
        divider: {
            width: '100%',
        },
        radioIcon: {
            color: mainTheme.BrandColors.TemplatePrimary
        },
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        // top-aligned, not bottom: the Follow Up Due beside the Reminder grows taller when it shows its "required" message, and a bottom-aligned
        // Reminder was pushed down with it. Both fields are the same height, so at the top they stay level.
        selector: {
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start'
        },
        subHeading: {
            paddingLeft: 25,            
            paddingBottom: 25,
            color: theme.palette.text.secondary
        },
        // ---- styling shared with the email template dialog (EmailTemplateDialog.tsx) ----
        dialog: {
            '& .MuiDialog-paper': {
                maxHeight: '92vh',
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'hidden',
            },
        },
        dialogHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: theme.spacing(2, 2.5),
            borderBottom: `1px solid ${theme.palette.divider}`,
            flexShrink: 0,
        },
        titleText: {
            fontSize: 15,
            fontWeight: 700,
            color: theme.palette.text.primary,
        },
        titleSub: {
            fontSize: 12,
            color: theme.palette.text.secondary,
            marginTop: 2,
        },
        closeButton: {
            color: theme.palette.text.secondary,
            padding: 6,
        },
        dialogContent: {
            padding: theme.spacing(2, 2.5),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1.5),
            overflowY: 'auto',
            flex: 1,
        },
        sectionLabel: {
            fontSize: 11,
            fontWeight: 700,
            color: theme.palette.text.secondary,
            letterSpacing: '0.07em',
            textTransform: 'uppercase',
            marginBottom: theme.spacing(1),
        },
        fieldsCard: {
            backgroundColor: theme.palette.grey[50],
            borderRadius: 10,
            border: `1px solid ${theme.palette.divider}`,
            padding: theme.spacing(1.5),
        },
        // "What's next" heading and notices, same as the Follow Up panel in the Enquiry form
        followUpHeading: {
            fontSize: 14,
            fontWeight: 700,
            color: theme.palette.text.primary,
        },
        followUpHeadingSpaced: {
            marginTop: 8,
        },
        followUpSubtext: {
            fontSize: 12.5,
            color: theme.palette.text.secondary,
            marginTop: 2,
        },
        outcomeNotice: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 6,
            fontSize: 12.5,
            lineHeight: 1.4,
            borderRadius: 10,
            padding: '8px 10px',
            '& svg': {
                fontSize: 16,
                flexShrink: 0,
                marginTop: 1,
            },
        },
        outcomeNoticeGreen: {
            color: 'var(--rv-accent-green)',
            backgroundColor: 'var(--rv-accent-green-bg)',
            border: '1px solid rgba(27,127,59,0.25)',
        },
        outcomeNoticeOrange: {
            color: 'var(--rv-accent-orange)',
            backgroundColor: 'var(--rv-accent-orange-bg)',
            border: '1px solid rgba(224,90,0,0.25)',
        },
        toField: {
            '& .MuiOutlinedInput-root': {
                backgroundColor: 'var(--rv-accent-blue-bg)',
                fontWeight: 600,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--rv-accent-blue)',
                borderWidth: 1.5,
            },
            '& .MuiInputLabel-root': {
                color: 'var(--rv-accent-blue)',
                fontWeight: 700,
            },
        },
        sectionHint: {
            fontSize: 12,
            color: theme.palette.text.secondary,
            marginTop: -8,
            marginBottom: theme.spacing(1),
        },
        editorWrapper: {
            borderRadius: 8,
            overflow: 'hidden',
            border: `1px solid ${theme.palette.divider}`,
            '& .tox-tinymce': {
                border: 'none !important',
            },
        },
        dialogActions: {
            padding: theme.spacing(1.5, 2.5),
            borderTop: `1px solid ${theme.palette.divider}`,
            gap: theme.spacing(1),
            flexShrink: 0,
        },
        cancelBtn: {
            fontSize: 13,
            textTransform: 'none',
            color: theme.palette.text.secondary,
        },
    })
);

export enum ControlType {
    quill = 0,
    tinyMce = 1
}

interface SendEmailState {
    isFormChanged: boolean;
    showDiscard: boolean;

    emailContent: string;
    emailSubject?: string | null;
    fromEmailAddress?: string | null;
    toEmailAddress?: string | null;
    ccEmailAddress?: string | null;

    controlType: ControlType;
    emailContentCopy: string;
    files: DocumentFile[];
    fileSizeLimit: number;
}

export interface SendEmailProps {
    enquiryGuid: string;
    emailTemplateGuid: string;
    emailTemplateName: string;
    followUpAction: string;
    followUpActionSystemName: string;
    followUpDate: Date | null;
    toEmailAddress: string | null;
    fromEmailAddress: string | null;
    emailType: EmailTemplateTypeEnum;

    onDialogClose?: () => void;
    isSendEmailDialogOpen: boolean;
    matter?: IAutoCompleteItem;
    enquiryDefaultConfig?: EnquiryDefaultConfig;
    canCreateMatter: boolean | undefined;
    messageType: EmailTemplateMessageTypeEnum;
    mobileNumber?: string | null;
}

// tslint:disable-next-line: no-anyW
export const SendEmailDialog: React.FC<SendEmailProps> = ( props ) => {

    // tslint:disable-next-line: no-console
    // console.log('enquiryDefaultConfig', props.enquiryDefaultConfig);
    
    const classes = useStyles();

    const [isLoading, setIsLoading] = useState(true);
    const { isSaving, startSaving, finishSaving } = useSaveInFlight();
    const dialogContentRef = useRef<HTMLDivElement>(null);

    const applicationSettingsQuery = useApplicationSettings();

    const [state, setState] = useState<SendEmailState>({
        showDiscard: false,
        isFormChanged: false,

        emailContent: '',
        emailSubject: null,
        fromEmailAddress: null,
        toEmailAddress: props.toEmailAddress,
        ccEmailAddress: props.fromEmailAddress, // Set the from Email to cc as well. This helps with document management systems

        controlType: ControlType.quill,
        emailContentCopy: '',
        files: [],
        fileSizeLimit: 0,
    });

    useEffect(() => {
        if (!applicationSettingsQuery.loading && !applicationSettingsQuery.error && applicationSettingsQuery.data) {

            // tslint:disable-next-line: no-console
            // console.log('time', applicationSettingsQuery.data);

            setState((prevState) => {
                return {
                    ...prevState,
                    fileSizeLimit: applicationSettingsQuery.data?.settings.applications.systemOptions.config.emailSizeLimit || 0
                };
            });
        }
    },
    [applicationSettingsQuery.data, applicationSettingsQuery.loading, applicationSettingsQuery.error]);

    useEffect(() => {
        // - Ran only once
        setIsLoading(true);
        fetchEmailContentData();
        
    // tslint:disable-next-line: align
    }, [props.emailTemplateGuid]);
      
    const fetchEmailContentData = () => {
        var params: EmailDetailQueryParams = {
            enquiryGuid: props.enquiryGuid,
            emailTemplateGuid: props.emailTemplateGuid,
            emailType: EmailTemplateTypeEnum[props.emailType]
        };

        fetchEmailContent(
            params,
            true,
            (data: TemplatedData) => {
                handleEmailDetailFetch(data);
            },
            (reason) => {
                showNotification('Failed to Fetch App User Settings', reason, 'error');
                setIsLoading(false);
            }
        );
    };

    const handleEmailDetailFetch = (data?: TemplatedData) => {
        if (
            data !== null &&
            data?.templates !== undefined &&
            data.templates.emailDetail !== undefined
        ) {
            const emailDetail = data.templates.emailDetail;

            setState((prevState) => {
                return {
                    ...prevState,
                    // fromEmailAddress: data.templates.emailDetail.fromAddress,
                    // toAddresses: emailDetail.toAddresses,
                    ccAddresses: emailDetail.ccAddresses,
                    emailType: emailDetail.emailType,
                    emailStyle: emailDetail.emailStyle,
                    emailSubject: emailDetail.emailSubject,
                    emailContent: emailDetail.emailContent,

                    emailContentCopy: emailDetail.emailContent,
                    files: emailDetail.files
                };
            });

            setIsLoading(false);
        }
    };

    const onSubmit = (values: FollowUp) => {
        if (!startSaving()) {
            return;
        }
        saveFollowUp(values);
    };

    // Send email is also a follow up. We send the email at the end of the mutation
    const saveFollowUp = (values: FollowUp) => {        
        // Save the File
        client.mutate({
            mutation: FollowUpEnquiryMutation,
            variables: {
                input: getFollowUpEnquiryInput(values)
            },
        })
        // tslint:disable-next-line: no-any
        .then((results: { data: any; }) => { 
            if (results.data) {
                if (results.data.error === null || results.data.error === undefined) {
                    showNotification(null, 'Successfully submitted', 'info'); 

                    onFollowUpClosed();
                } else {
                    showNotification('Failed to Save Follow up', results.data.error, 'error'); 
                }
            }            
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => { showNotification('Failed to Save Follow up', reason, 'error'); })
            .finally(() => finishSaving());        
    };

    const getFollowUpEnquiryInput = (values: FollowUp) => {
        let sendEmailResponse = true;
        let sendDataCollectionResponse = false;

        if (props.followUpActionSystemName === 'SendDataForm') {
            sendEmailResponse = false;
            sendDataCollectionResponse = true;
        }

        return {
            enquiryGuid: props.enquiryGuid,
            followUpAction: props.followUpAction,
            followUpActionSystemName: props.followUpActionSystemName,
            followUpDate: values.followUpDate === null ? moment().toDate() : moment(values.followUpDate).toDate(),
            outcome: values.outcome,
            outcomeDate: values.outcome === 'New Client' || values.outcome === 'New Matter' || values.outcome === 'Not Proceeding' 
                            ? !values.followUpDate ? null : moment(values.followUpDate).toDate()
                            : !values.outcomeDate ? null : moment(values.outcomeDate).toDate(),
            outcomeNotes: values.outcomeNotes,
            reason: values.reason,
            reasonGuid: values.reasonGuidID,
            followUpNotes: values.followUpNotes,

            sendEmailResponse: sendEmailResponse,
            sendDataCollectionResponse: sendDataCollectionResponse,
            emailContent: state.emailContent, // using value.emailContent is giving an issue
            emailSubject: values.emailSubject,
            emailTemplateName: props.emailTemplateName,
            fromEmailAddress: values.fromEmailAddress,
            toEmailAddresses: values.toEmailAddress,
            ccEmailAddresses: values.ccEmailAddress,
            templateGuid: props.emailTemplateGuid,

            reminderOffset: values.outcome === 'More Follow Up'
                ? (values.followUpDueReminder ? values.followUpDueReminder.value : null)
                : null,

            files: GetFiles(values.files as SendEmailFile[]),
            messageType: props.messageType === EmailTemplateMessageTypeEnum.EMAIL ? 0 : 1,
            toMobileNumber: props.mobileNumber,
            autoFollowUpTemplateGuid: values.isAutoFollowUp && values.autoFollowUpEmailTemplate ? values.autoFollowUpEmailTemplate.value : null
        };
    };

    const GetFiles = (files: SendEmailFile[]) => getFilesToSend(files);

    const onFollowUpClosed = () => {
        if (props.onDialogClose) {
            props.onDialogClose();
        }
    };

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (form: FormApi<any>, changeProps: any) => {
        // outcome is set by OutcomeSegmentedControl (no <Field>), so pristine does not see it - compare it with its initial value
        // tslint:disable-next-line: no-any
        const initialValues = form.getState().initialValues as any;
        const hasChangedOutcome = !!changeProps.values && !!initialValues && changeProps.values.outcome !== initialValues.outcome;

        if (!changeProps.pristine || hasChangedOutcome) {
            form.change('isFormChanged', true);
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // Send with a field missing: the dialog's content scrolls, so the field that needs filling can be out of sight. Jump to the first one and focus it.
    // tslint:disable-next-line: no-any
    const onSendClick = (form: FormApi<any>) => {
        form.submit();
        if (form.getState().invalid) {
            // after the errors have been drawn, so the invalid fields can be found
            window.setTimeout(() => {
                const invalidFields = dialogContentRef.current
                    ? Array.from(dialogContentRef.current.querySelectorAll<HTMLElement>('[aria-invalid="true"]'))
                    : [];
                // fields hidden by the outcome (display: none) have no size and cannot take focus
                const firstVisibleInvalidField = invalidFields.find((field) => field.getClientRects().length > 0);
                if (firstVisibleInvalidField) {
                    firstVisibleInvalidField.scrollIntoView({ block: 'center' });
                    firstVisibleInvalidField.focus();
                }
            },                      0);
        }
    };

    const onClose = () => {
        if (state.isFormChanged) {
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: true
                };
            });
        } else {
            onFollowUpClosed();
        }
    };

    // tslint:disable-next-line: no-any
    const onDiscardChanges = (agree: boolean) => {
        if (agree) {
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: false
                };
            });

            onFollowUpClosed();
            
        } else {
            // showDiscard false
            // form.change('showDiscard', false);
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: false
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    const required = (value: any) => {
        return value ? undefined : 'Required';
    };

    // Same header as the email template dialog: bold title, small subtitle, close button.
    const renderDialogHeader = () => (
        <div className={classes.dialogHeader}>
            <div>
                <Typography className={classes.titleText} id="form-dialog-title">
                    {props.messageType === EmailTemplateMessageTypeEnum.EMAIL ? 'Send Email' : 'Send SMS'}
                </Typography>
                <Typography className={classes.titleSub}>
                    {props.messageType === EmailTemplateMessageTypeEnum.SMS
                        ? `To: ${props.mobileNumber}`
                        : props.emailTemplateName ? `Using the "${props.emailTemplateName}" template` : ''}
                </Typography>
            </div>
            <IconButton className={classes.closeButton} size="small" onClick={() => onClose()} aria-label="Close">
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    );

    const displayLoader = () => {
        if (isLoading) {
            // return <RvLoader />;
            return (
                <Dialog
                    open={props.isSendEmailDialogOpen}
                    onClose={() => onClose()}
                    className={classes.dialog}
                    fullWidth={true}
                    maxWidth="lg"
                >
                    {renderDialogHeader()}
                    <DialogContent className={classes.dialogContent} dividers={false}>
                        <SkeletonLoader variant="form" rows={4} columns={1} />
                    </DialogContent>
                    <DialogActions className={classes.dialogActions} disableSpacing={true}>
                        <SkeletonLoader variant="shape" shape="text" width={90} height={34} />
                    </DialogActions>
                </Dialog>

            );
        } else {
            return null;
        }
    };

    // tslint:disable-next-line
    const emailRegex = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // tslint:disable-next-line: no-any
    const EmailValidateWithRequiredNew = (value: any) => {
        let error: string = '';

        if (value === undefined || value === null) {
            return value ? '' : 'Email is required';
        } else if (value.length === 0) {
            return value ? '' : 'Email is required'; 
        } else if (!emailRegex.test(value)) {
            error = 'Email is not valid';
        }
        return error;
    };

    // tslint:disable-next-line: no-any
    const EmailValidate = (value: any) => {
        let error: string = '';

        if (value !== undefined && value !== null) {
            if (!emailRegex.test(value)) {
                error = 'Email is not valid';
            }
        }
        
        return error;
    };

    // tslint:disable-next-line: no-any
    const requiredDateValidator = (value: any) => {
        if (value) {
            // check for a valid date and check for sql's min date
            var date = moment(value);

            if (date.isValid() && date.year() >= 1753) {
                return undefined;
            } else {
                return 'Incorrect Date';
            }
        } else {
            return 'Required';
        }
    };

    // tslint:disable-next-line: no-any
    const onOutcomeChange = (form: FormApi<any>, values: any, event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {        
        const outcome = event && event.currentTarget && event.currentTarget.value ? event.currentTarget.value : '';
        form.change('outcome', outcome);

        form.change('reason', null);
        form.change('reasonGuid', null);
        // if (outcome && !values.outcomeDate) {
        //     form.change('outcomeDate', values.followUpDate);
        // }
    };

    // tslint:disable-next-line: no-any
    const onDropdownChange = (selection: IAutoCompleteItem, name: string, input: FieldInputProps<any, HTMLElement>, form: FormApi<any>, 
                              valueGuid: string) => {
        input.onChange(selection.label.length > 0 ? selection.label : null);

        if (name === 'reason') {
            form.change('reasonGuidID', valueGuid.length > 0 
                ? valueGuid 
                : null);
        } else if (name === 'notProceedingReason') {
            form.change('notProceedingReasonGuid', valueGuid.length > 0 
                ? valueGuid 
                : null);
        }       
    };

    const getReminderValue = () => {
        if (props.enquiryDefaultConfig && props.enquiryDefaultConfig.reminder) {
            return { label: props.enquiryDefaultConfig.reminder, value: props.enquiryDefaultConfig.reminder };
        } else {
            return { label: 'None', value: 'None'};
        }
    };

    const getOutcomeDateDefaultValue = () => {
        // check outcome date (FollowUpDue)
        let outcomeDate: Date | null = null;
        
        if (props.enquiryDefaultConfig) {

            let hours = 0;
            let minutes = 0;
            let validTimeOfDay = false;
            
            if (props.enquiryDefaultConfig.timeOfDay && props.enquiryDefaultConfig.timeOfDay.toLowerCase() !== 'invalid date') {
                var timeOfDaySplit = props.enquiryDefaultConfig.timeOfDay ? props.enquiryDefaultConfig.timeOfDay.split(':') : null;
            
                if (timeOfDaySplit) {
                    validTimeOfDay = true;
                    hours = Number(timeOfDaySplit[0]);
                    minutes = Number(timeOfDaySplit[1]);
                }
            }           

            if (props.enquiryDefaultConfig.isCalculatedDays) {
                let date = addBusinessDays(moment().toDate(), props.enquiryDefaultConfig.addDays ? props.enquiryDefaultConfig.addDays : 0);
               
                if (validTimeOfDay) {
                    outcomeDate = date
                        .set('hour', hours)
                        .set('minute', minutes)
                        .toDate();
                } else {
                    outcomeDate = date.toDate();
                }
            } else if (props.enquiryDefaultConfig.isCalculatedHours) {
                let addhours = props.enquiryDefaultConfig.addHours ? props.enquiryDefaultConfig.addHours : 0;
    
                outcomeDate = moment()
                    .add(addhours, 'hour')
                    .toDate();
            }

            // Manual default time is set through getOutcomeDefaultTime()
        }       

        return outcomeDate;
    };

    const getOutcomeDefaultTime = () => {
        let defaultTime = new Date().setHours(17, 0, 0, 0);

        let hours = 0;
        let minutes = 0;        

        if (props.enquiryDefaultConfig && props.enquiryDefaultConfig.isManualEntry 
            && props.enquiryDefaultConfig.timeOfDay && props.enquiryDefaultConfig.timeOfDay.toLowerCase() !== 'invalid date') {
            var timeOfDaySplit = props.enquiryDefaultConfig.timeOfDay ? props.enquiryDefaultConfig.timeOfDay.split(':') : null;

            if (timeOfDaySplit) {
                hours = Number(timeOfDaySplit[0]);
                minutes = Number(timeOfDaySplit[1]);
            }

            defaultTime = new Date().setHours(hours, minutes, 0, 0);
        } 

        return defaultTime;
    };

    return (
        <React.Fragment>
            {
                isLoading || applicationSettingsQuery.loading
                    ? displayLoader()
                    : (
                        <Form
                            onSubmit={onSubmit}
                            initialValues={{                    
                                followUpAction: props.followUpAction,
                                followUpDate: props.followUpDate, 
                                followUpActionSystemName: props.followUpActionSystemName,                                                   
                                followUpNotes: '',
                                hasFollowUpNotesMentions: false,
                                outcome: 'More Follow Up',
                                outcomeDate: getOutcomeDateDefaultValue(),
                                outcomeNotes: '',
                                reason: null,
                                reasonGuid: null,
                                isFormChanged: false,
                                staff: null,
                                startTime: moment().toDate(), 
                                endTime: moment().add(1, 'hour').toDate(),
                                isAllDay: false,
                                officeLocation: null,
                                feeApplicable: null,
                                isSendConfirmation: false,
                                meetingNotes: null,

                                emailContent: state.emailContent,
                                emailSubject: state.emailSubject,
                                fromEmailAddress: props.fromEmailAddress,
                                toEmailAddress: props.toEmailAddress,
                                ccEmailAddress: state.ccEmailAddress,

                                followUpDueReminder: getReminderValue(),
                                files: state.files.map(toAttachedFile),
                                autoFollowUpEmailTemplate: props.enquiryDefaultConfig && props.enquiryDefaultConfig.emailTemplateGuid && props.enquiryDefaultConfig.emailTemplateName ?
                                    {
                                        label: props.enquiryDefaultConfig.emailTemplateName,
                                        value: props.enquiryDefaultConfig.emailTemplateGuid
                                    } : null,
                                isAutoFollowUp: props.enquiryDefaultConfig?.isAutoFollowUp ? props.enquiryDefaultConfig.isAutoFollowUp : false,
                            }}
                            initialValuesEqual={() => true}
                            subscription={{submitting: true, pristine: true}}
                            validate={(values) => {
                                if (props.messageType === EmailTemplateMessageTypeEnum.SMS) {
                                    return undefined;
                                } else {
                                    let errors = {
                                        fromEmailAddress: '',
                                        toEmailAddress: '',
                                        ccEmailAddress: ''
                                    };

                                    if ((!values.fromEmailAddress) 
                                        && (!values.toEmailAddress)) {
                                        errors.fromEmailAddress = 'From email address is required';
                                        errors.toEmailAddress = 'To email address is required';
                                    } else if (values
                                        && (values.fromEmailAddress && values.fromEmailAddress.length === 0)
                                        && (values.toEmailAddress && values.toEmailAddress.length === 0)) {
                                        errors.fromEmailAddress = 'From email address is required';
                                        errors.toEmailAddress = 'To email address is required';
                                    } else if (
                                            (values.fromEmailAddress !== undefined && values.fromEmailAddress !== null 
                                                && values.fromEmailAddress.length > 0) 
                                            || (values.toEmailAddress !== undefined && values.toEmailAddress !== null 
                                                && values.toEmailAddress.length > 0) 
                                            || (values.ccEmailAddress !== undefined && values.ccEmailAddress !== null 
                                                && values.ccEmailAddress.length > 0) 
                                        ) {
                                        errors.fromEmailAddress = EmailValidateWithRequiredNew(values.fromEmailAddress);
                                        errors.toEmailAddress = EmailValidateWithRequiredNew(values.toEmailAddress);
                                        errors.ccEmailAddress = EmailValidate(values.ccEmailAddress);
                                    }
                                        
                                    if (errors.fromEmailAddress === '' && errors.toEmailAddress === '' && errors.ccEmailAddress === '') {
                                        return undefined;
                                    }

                                    return errors;
                                }
                            }}
                            render={({handleSubmit, form, submitting, pristine, values}) => (
                                <form onSubmit={event => handleSubmit(event)} id="sendEmailDialog" autoComplete="off">
                                    {displayLoader()}
                                    <FormSpy 
                                        subscription={{ pristine: true, values: true }}
                                        // tslint:disable-next-line: no-shadowed-variable
                                        onChange={props => {
                                            onFormValueChanged(form, props);
                                        }}
                                    />                        
                                    <DialogBox
                                        title="Send Email"
                                        // tslint:disable-next-line:max-line-length
                                        content={`Are you sure you want to close the form?`}
                                        show={state.showDiscard ? state.showDiscard : false}
                                        isAgree={onDiscardChanges}
                                        disAgreeLabel={'No'}
                                        agreeLabel={'Yes'}
                                    />
                                    
                                    <Dialog
                                        open={props.isSendEmailDialogOpen}
                                        onClose={() => onClose()}
                                        className={classes.dialog}
                                        fullWidth={true}
                                        maxWidth="lg"
                                        disableEnforceFocus={true}
                                    >
                                        {renderDialogHeader()}
                                        <DialogContent ref={dialogContentRef} className={classes.dialogContent} dividers={false}>
                                                <FormSpy subscription={{ values: true, validating: true }}>
                                                    {/* tslint:disable-next-line: no-shadowed-variable */}
                                                    {({ values }) => (
                                                        <>
                                                            {(props.messageType === EmailTemplateMessageTypeEnum.EMAIL) && (
                                                                    <div>
                                                                        <Typography className={classes.sectionLabel}>Message Details</Typography>
                                                                        <div className={classes.fieldsCard}>
                                                                            <Grid container={true} spacing={1}>
                                                                    <Grid item={true} xs={12} sm={6}>
                                                                        <Field
                                                                            name="fromEmailAddress"
                                                                            type="email"
                                                                            subscription={{touched: true, error: true, value: true}}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <div>
                                                                                    <TextField
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        {...input}
                                                                                        id="send-email-from"
                                                                                        label="From"
                                                                                        type="email"
                                                                                        required={true}
                                                                                        className={classes.textField}
                                                                                        error={meta.error && meta.touched}
                                                                                        autoComplete="abcd"
                                                                                        helperText={
                                                                                            meta.error &&
                                                                                            meta.touched
                                                                                                ? meta.error
                                                                                                : ''
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Field>
                                                                    </Grid>
                                                                    <Grid item={true} xs={12} sm={6}>
                                                                        <Field
                                                                            name="toEmailAddress"
                                                                            type="email"
                                                                            subscription={{touched: true, error: true, value: true}}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <div>
                                                                                    <TextField
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        {...input}
                                                                                        id="send-email-to"
                                                                                        label="To"
                                                                                        type="email"
                                                                                        disabled={props.emailType === EmailTemplateTypeEnum.EnquiryDataCollection}
                                                                                        required={true}
                                                                                        className={clsx(classes.textField, classes.toField)}
                                                                                        error={meta.error && meta.touched}
                                                                                        autoComplete="abcd"
                                                                                        helperText={
                                                                                            meta.error &&
                                                                                            meta.touched
                                                                                                ? meta.error
                                                                                                : ''
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Field>
                                                                    </Grid>
                                                                    <Grid item={true} xs={12}>
                                                                        <Field
                                                                            name="ccEmailAddress"
                                                                            type="email"
                                                                            subscription={{touched: true,  error: true, value: true}}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <div>
                                                                                    <TextField
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        {...input}
                                                                                        id="send-email-cc"
                                                                                        label="Cc"
                                                                                        type="email"
                                                                                        required={undefined}
                                                                                        className={classes.textField}
                                                                                        error={
                                                                                            meta.error &&
                                                                                            meta.touched
                                                                                        }
                                                                                        autoComplete="abcd"
                                                                                        helperText={
                                                                                            meta.error &&
                                                                                            meta.touched
                                                                                                ? meta.error
                                                                                                : ''
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Field>
                                                                    </Grid>
                                                                    <Grid item={true} xs={12}>
                                                                        <Field
                                                                            name="emailSubject"
                                                                            type="text"
                                                                            validate={required}
                                                                            subscription={{touched: true,  error: true, value: true}}
                                                                        >
                                                                            {({ input, meta }) => (
                                                                                <div>
                                                                                    <TextField
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        {...input}
                                                                                        id="send-email-subject"
                                                                                        label="Subject"
                                                                                        type="text"
                                                                                        required={true}
                                                                                        className={classes.textField}
                                                                                        error={
                                                                                            meta.error &&
                                                                                            meta.touched
                                                                                        }
                                                                                        autoComplete="abcd"
                                                                                        helperText={
                                                                                            meta.error &&
                                                                                            meta.touched
                                                                                                ? meta.error
                                                                                                : ''
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Field>
                                                                    </Grid>
                                                                            </Grid>
                                                                        </div>
                                                                    </div>
                                                            )}
                                                            <div>
                                                                <Typography className={classes.sectionLabel}>Message</Typography>
                                                                <Field
                                                                    name="emailContent"
                                                                    type="text"
                                                                    validate={required}
                                                                    subscription={{touched: true,  error: true, value: true}}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <div className={classes.editorWrapper}>
                                                                        <EditorWrapper
                                                                            // disabledAI={true}
                                                                            showLoadingSkeleton={true}
                                                                            value={state.emailContent}
                                                                            onEditorChange={(content: string) => {
                                                                                setState((prevState) => {
                                                                                    return {
                                                                                        ...prevState,
                                                                                        emailContent: content
                                                                                    };
                                                                                });
                                                                            }}
                                                                            messageType={props.messageType}
                                                                        />
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                                                                                            </div>
                                                            {(props.messageType === EmailTemplateMessageTypeEnum.EMAIL) && (
                                                                <>
                                                                    <div>
                                                                        <Typography className={classes.sectionLabel}>Attachments</Typography>
                                                                        <Typography className={classes.sectionHint}>These files are sent with the email.</Typography>
                                                                        <div className={classes.fieldsCard}>
                                                                            <Field name="files" validate={validateAttachedFiles}>
                                                                                {(fieldProps) => (
                                                                                    <AttachmentsField
                                                                                        {...fieldProps}
                                                                                        input={{
                                                                                            ...fieldProps.input,
                                                                                            onChange: (nextFiles: AttachedFile[]) => fieldProps.input.onChange(dropDuplicateAttachments(fieldProps.input.value || [], nextFiles)),
                                                                                        }}
                                                                                        acceptedTypes={null}
                            compact={true}
                                                                                        maxFiles={50}
                                                                                        maxFileSizeMb={state.fileSizeLimit || undefined}
                                                                                        maxFileSizeBytes={state.fileSizeLimit ? state.fileSizeLimit * 1_048_576 : undefined}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                            <div>
                                                                <Typography className={classes.sectionLabel}>Follow Up</Typography>
                                                                <div className={classes.fieldsCard}>
                                                                    <Grid container={true} spacing={2}>
                                                            <Grid item={true} xs={12}>
                                                                <Field
                                                                    name="followUpNotes"
                                                                    subscription={{ touched: true, error: true, value: true }}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <ConnectedCannedNotesForField selectedActionName={props.followUpAction} value={input.value} onChange={(newValue: string) => input.onChange(newValue)}>
                                                                            {({ pickerNode, confirmationNode }) => (
                                                                                <>
                                                                                    <SpeechTextFieldWithMarkup
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        input={input}
                                                                                        className={classes.textField}
                                                                                        label="Follow Up Notes"
                                                                                        markup="@[__display__](user:__id__)"
                                                                                        // tslint:disable-next-line: max-line-length
                                                                                        onChange={(event: { target: { value: string } }, newValue: string, 
                                                                                                   newPlainTextValue: string, mentions: MentionItem[]) => {
                                                                                            input.onChange(newValue);
                                                                                            if (mentions && mentions.length > 0) {
                                                                                                form.change('hasFollowUpNotesMentions', true);
                                                                                                // tslint:disable-next-line: max-line-length
                                                                                                // If we have mentions, change the Follow Up Action to - Internal Note
                                                                                                // And mark Follow Up Due as not mandatory
                                                                                                form.change('followUpAction', 'Internal Note');
                                                                                                form.change('followUpActionSystemName', 'InternalNote');
                                                                                            } else {
                                                                                                form.change('hasFollowUpNotesMentions', false);
                                                                                            }                                                  
                                                                                        }}
                                                                                        isLoadData={true}
                                                                                        onlyUsedByEnquiries={true}
                                                                                        endAdornmentExtra={pickerNode}
                                                                                    />
                                                                                    {confirmationNode}
                                                                                </>
                                                                            )}
                                                                        </ConnectedCannedNotesForField>
                                                                    )}
                                                                </Field>
                                                            </Grid>
                                                            <Grid item={true} xs={12}>
                                                                <Divider />
                                                                <Typography className={clsx(classes.followUpHeading, classes.followUpHeadingSpaced)}>What&apos;s next</Typography>
                                                                <Typography className={classes.followUpSubtext}>Choose the outcome, then schedule the next step if there is one.</Typography>
                                                            </Grid>
                                                            <Grid item={true} xs={12}>
                                                                <Grid container={true} spacing={2}>
                                                                    <Grid item={true} xs={12}>
                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'space-between',
                                                                                gap: '10px',
                                                                            }}
                                                                        >
                                                                            <OutcomeSegmentedControl
                                                                                name="outcome"
                                                                                label="Outcome"
                                         value={values.outcome}
                                                                                hasNameGuid={values.nameGuid ? true : false}
                                                                                canCreateMatter={props.canCreateMatter}
                                                                                // tslint:disable-next-line: max-line-length
                                                                                onRadioButtonChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) =>
                                                                                    onOutcomeChange(form, values, event, checked)
                                                                                }
                                                                            />
                                                                            
                                                                            {UserFeature.HasAccess(UserFeatureEnum.hasEnquiryAutoFollowUp) && values.outcome === 'More Follow Up' && props.emailType !== EmailTemplateTypeEnum.EnquiryDataCollection ? (
                                                                                <Field
                                                                                    name="isAutoFollowUp"
                                                                                    // tslint:disable-next-line: max-line-length
                                                                                    // validate={values.followUpDate !== null && values.outcome === 'More Follow Up' ? requiredDateValidator : undefined}
                                                                                    subscription={{ touched: true, error: true, value: true }}
                                                                                >
                                                                                    {({ input, meta }) => (
                                                                                        <FormControl component="fieldset">
                                                                                            <FormLabel 
                                                                                                component="legend"
                                                                                                style={{
                                                                                                    color: 'transparent'
                                                                                                }}
                                                                                            >
                                                                                                Auto Follow Ups
                                                                                            </FormLabel>
                                                                                            <FormControlLabel
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={input.value}
                                                                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                                                            input.onChange(event.target.checked);
                                                                                                        }}
                                                                                                        name="isAutoFollowUp"
                                                                                                        disabled={!values.toEmailAddress}
                                                                                                        color="primary"
                                                                                                    />
                                                                                                }
                                                                                                label={
                                                                                                    <Typography 
                                                                                                        color="inherit"
                                                                                                        style={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            gap: '5px',
                                                                                                        }}
                                                                                                    >
                                                                                                        Auto Follow Up
                                                                                                        <LightTooltip
                                                                                                            title={
                                                                                                                <Typography 
                                                                                                                    color="inherit"
                                                                                                                    style={{
                                                                                                                        maxWidth: '300px'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    Selecting this check box will allow an email to be automatically sent to the enquirer at the due date/time, rather than a reminder being sent to the assignee.
                                                                                                                </Typography>
                                                                                                            }
                                                                                                            placement="top"
                                                                                                            arrow={true}
                                                                                                        >
                                                                                                            <InfoOutlinedIcon fontSize="small" />
                                                                                                        </LightTooltip>
                                                                                                    </Typography>
                                                                                                }
                                                                                            />
                                                                                        </FormControl>
                                                                                    )}
                                                                                </Field>
                                                                            ) : null}
                                                                        </div>
                                                                    </Grid>     

                                                                    {UserFeature.HasAccess(UserFeatureEnum.hasEnquiryAutoFollowUp) && values.isAutoFollowUp && values.outcome === 'More Follow Up' ? (
                                                                        <Grid item={true} xs={12}>
                                                                            <Grid container={true} spacing={3}>
                                                                                <Grid item={true} xs={6} md={6}>
                                                                                    <Field
                                                                                        name="autoFollowUpEmailTemplate"
                                                                                        // tslint:disable-next-line: max-line-length
                                                                                        // validate={values.followUpDate !== null && values.outcome === 'More Follow Up' ? requiredDateValidator : undefined}
                                                                                        subscription={{ touched: true, error: true, value: true }}
                                                                                        validate={values.isAutoFollowUp ? required : undefined}
                                                                                    >
                                                                                        {({ input, meta }) => (
                                                                                            <EmailResponseTemplateSelector
                                                                                                variant="outlined"
                                                                                                {...input}
                                                                                                label="Email Template"
                                                                                                disabled={!values.toEmailAddress}
                                                                                                className={classes.textField}
                                                                                                onSelection={(selection: IAutoCompleteItem) => {
                                                                                                    input.onChange(selection);
                                                                                                }}
                                                                                                error={meta.error && meta.touched}
                                                                                                helperText={meta.error && meta.touched ? meta.error : ''}
                                                                                                size="small"
                                                                                                required={values.isAutoFollowUp ? true : false}
                                                                                            />
                                                                                        )}
                                                                                    </Field>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    ) : null}

                                                                    {values.outcome === 'Proceeding' && (
                                                                        <Grid item={true} xs={12}>
                                                                            <div className={clsx(classes.outcomeNotice, classes.outcomeNoticeGreen)}>
                                                                                <InfoOutlinedIcon fontSize="small" />
                                                                                <span>
                                                                                    Marked as proceeding. No further follow-ups will be scheduled. After you save, you can create a matter or attach an existing one.
                                                                                </span>
                                                                            </div>
                                                                        </Grid>
                                                                    )}

                                                                    {values.outcome === 'Not Proceeding' && (
                                                                        <Grid item={true} xs={12}>
                                                                            <div className={clsx(classes.outcomeNotice, classes.outcomeNoticeOrange)}>
                                                                                <InfoOutlinedIcon fontSize="small" />
                                                                                <span>Marked as not proceeding - no further follow-ups will be scheduled.</span>
                                                                            </div>
                                                                        </Grid>
                                                                    )}

                                                                    <Grid item={true} xs={12}>
                                                                        <Grid container={true} spacing={2}>
                                                                            {/* Without FormSpy, rules will not update in Realtime */}
                                                                            <Grid 
                                                                                item={true} 
                                                                                xs={12} 
                                                                                sm={6} 
                                                                                // tslint:disable-next-line: max-line-length
                                                                                className={values.outcome === 'More Follow Up' ? '' : classes.hideDate}
                                                                            >
                                                                                <Field
                                                                                    name="outcomeDate"
                                                                                    // validate={values.outcome === 'More Follow Up' 
                                                                                    validate={
                                                                                        values.hasFollowUpNotesMentions 
                                                                                            // tslint:disable-next-line: max-line-length
                                                                                            ? undefined 
                                                                                            : values.followUpDate !== null && values.outcome === 'More Follow Up' 
                                                                                                ? requiredDateValidator 
                                                                                                : undefined
                                                                                    }
                                                                                    subscription={{ touched: true, error: true, value: true }}
                                                                                >
                                                                                    {({ input, meta }) => (
                                                                                        <div>
                                                                                            <KeyboardDateTimePicker
                                                                                                inputVariant="outlined"
                                                                                                size="small"
                                                                                                {...input}
                                                                                                className={classes.textField}
                                                                                                label="Follow Up Due"
                                                                                                format="DD/MM/YYYY hh:mm a"
                                                                                                placeholder="dd/mm/yyyy hh:mm a"
                                                                                                // tslint:disable-next-line: max-line-length
                                                                                                required={values.hasFollowUpNotesMentions 
                                                                                                        // tslint:disable-next-line: max-line-length
                                                                                                        ? false 
                                                                                                        // tslint:disable-next-line: max-line-length
                                                                                                        :  values.followUpDate !== null && values.outcome === 'More Follow Up'
                                                                                                            ? true 
                                                                                                            : false
                                                                                                }
                                                                                                animateYearScrolling={true}
                                                                                                // tslint:disable-next-line: max-line-length
                                                                                                autoOk={true}
                                                                                                allowKeyboardControl={true}
                                                                                                variant={'inline'}
                                                                                                error={meta.error && meta.touched}
                                                                                                helperText={
                                                                                                    meta.error && meta.touched 
                                                                                                        ? 'Follow Up Due is required' 
                                                                                                        : ''
                                                                                                }
                                                                                                inputProps={{autoComplete: 'off'}}
                                                                                                InputLabelProps={{shrink: true}}
                                                                                                // minDate={new Date()}
                                                                                                // tslint:disable-next-line: max-line-length
                                                                                                initialFocusedDate={getOutcomeDefaultTime()}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                </Field>
                                                                            </Grid>
                                                                            <Grid 
                                                                                item={true} 
                                                                                xs={12} 
                                                                                sm={6} 
                                                                                alignItems="flex-end"
                                                                                className={values.outcome === 'More Follow Up' && !values.isAutoFollowUp ? '' : classes.hideDate}
                                                                            >
                                                                                <Field
                                                                                    name="followUpDueReminder"
                                                                                    subscription={{touched: true, error: true, value: true}}
                                                                                >                                            
                                                                                    {({ input, meta }) => (
                                                                                        <div className={classes.selector}>
                                                                                            <ReminderSelector
                                                                                                variant="outlined"
                                                                                                size="small"
                                                                                                {...input}
                                                                                                label="Reminder" 
                                                                                                className={classes.textField}
                                                                                                onSelection={(selection: IAutoCompleteItem) => {
                                                                                                    input.onChange(selection);
                                                                                                }}
                                                                                                error={meta.error && meta.touched}
                                                                                                helperText={
                                                                                                    meta.error &&
                                                                                                    meta.touched
                                                                                                        ? meta.error
                                                                                                        : ''
                                                                                                }
                                                                                                showIcon={true}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                </Field>
                                                                            </Grid>
                                                                            <Grid 
                                                                                item={true} 
                                                                                xs={12}
                                                                                 
                                                                                // tslint:disable-next-line: max-line-length
                                                                                className={values.outcome === 'More Follow Up' && !values.isAutoFollowUp ? '' : classes.hideDate} 
                                                                            >
                                                                                <Field
                                                                                    name="outcomeNotes"
                                                                                    subscription={{ touched: true, error: true, value: true }}
                                                                                >
                                                                                    {({ input, meta }) => (
                                                                                        <div>
                                                                                            <TextField
                                                                                                variant="outlined"
                                                                                                size="small"
                                                                                                {...input}
                                                                                                label="Note for next follow-up"
                                                                                                type="text"
                                                                                                // required={true}
                                                                                                className={classes.textField}
                                                                                                error={meta.error && meta.touched}
                                                                                                autoComplete="abcd"
                                                                                                // helperText={
                                                                                                //     meta.error &&
                                                                                                //     meta.touched
                                                                                                //         ? 'Notes is required'
                                                                                                //         : ''
                                                                                                // }
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                </Field>
                                                                            </Grid>
                                                                            {/* Without FormSpy, rules will not update in Realtime */}
                                                                            <Grid 
                                                                                item={true} 
                                                                                xs={12}
                                                                                sm={6}
                                                                                // tslint:disable-next-line: max-line-length
                                                                                className={values.outcome === 'Not Proceeding' ? '' : classes.hideDate} 
                                                                            >
                                                                                <Field
                                                                                    name="reason"
                                                                                    // tslint:disable-next-line: max-line-length
                                                                                    validate={form.getFieldState('outcome')?.value === 'Not Proceeding' 
                                                                                                ? required 
                                                                                                : undefined
                                                                                    }
                                                                                    subscription={{ touched: true, error: true, value: true }}
                                                                                >
                                                                                    {({ input, meta }) => (
                                                                                        <div>
                                                                                            <ReasonSelector
                                                                                                variant="outlined"
                                                                                                size="small"
                                                                                                {...input}
                                                                                                label="Not Proceeding Reason"
                                                                                                name="reason"
                                                                                                className={classes.textField}
                                                                                                error={meta.error && meta.touched}
                                                                                                disablePortal={false}
                                                                                                // tslint:disable-next-line: max-line-length
                                                                                                onSelection={(selection: IAutoCompleteItem, name: string, reasonGuid: string) => {
                                                                                                    // tslint:disable-next-line: max-line-length
                                                                                                    onDropdownChange(selection, name, input, form, reasonGuid);
                                                                                                }}
                                                                                                // tslint:disable-next-line: max-line-length
                                                                                                required={form.getFieldState('outcome')?.value === 'Not Proceeding' 
                                                                                                        ? true : false}
                                                                                                disabled={form.getFieldState('outcome')?.value !== 'Not Proceeding' 
                                                                                                        ? true : false}
                                                                                            />
                                                                                        </div>

                                                                                    )}
                                                                                </Field>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                {/* <Divider className={classes.divider} /> */}
                                                            </Grid>
                                                            </Grid>
                                                            </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </FormSpy>
                                            {/* {printJson(values)} */}
                                        </DialogContent>
                                        <DialogActions className={classes.dialogActions} disableSpacing={true}>
                                            <FormSpy subscription={{ values: true, pristine: true, submitting: true }}>
                                                {/* tslint:disable-next-line: no-shadowed-variable */}
                                                {({ values, pristine }) => (
                                                    <>
                                                        <Button 
                                                            // tslint:disable-next-line: max-line-length
                                                            disabled={submitting || isSaving}
                                                            variant="contained"
                                                            color="primary"
                                                            type="submit"
                                                            startIcon={<SendOutlinedIcon />}
                                                            onClick={() => onSendClick(form)}
                                                        >
                                                            Send
                                                        </Button>
                                                        
                                                        <Button
                                                            className={classes.cancelBtn}
                                                            onClick={() => onClose()}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </>
                                                )}
                                            </FormSpy>                                
                                        </DialogActions>
                                    </Dialog>
                                </form>
                            )}
                        />
                    )
                }
        </React.Fragment>
    );
};

export interface TemplatedData {
    templates: Templates;
}

export interface Templates {
    emailDetail: EmailDetail;
}

export interface EmailDetail {
    id: number;
    fromAddress: string;
    toAddresses: string;
    ccAddresses: string;
    emailType: number;
    emailStyle: number;
    emailSubject: string;
    emailContent: string;
    files: DocumentFile[];
}

export interface EmailDetailQueryParams {
    emailType: string;
    emailTemplateGuid: string;
    enquiryGuid: string;
}

export function fetchEmailContent(query: EmailDetailQueryParams,
                                  refreshData: boolean,    
                                  onSuccess: (data?: TemplatedData) => void,
                                  // tslint:disable-next-line:no-any
                                  onError: (reason: any) => void)
: void {
    var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';

    client.query({
        query: EmailContentData,
        variables: {
            emailType: query.emailType,
            enquiryGuid: query.enquiryGuid,
            emailTemplateGuid: query.emailTemplateGuid
        },
        fetchPolicy: fetchPolicy
    })
    // tslint:disable-next-line:no-any
    .then((results: { data: any; }) => {
        onSuccess(results.data);
    })
    // tslint:disable-next-line:no-any
    .catch((reason: any ) => { onError(reason); });
}

export const EmailContentData = gql`
query templateWithEmailBodyForEnquiry ($emailType: EmailType, $emailTemplateGuid: String, $enquiryGuid: String) {
    templates {
        emailDetail (
            emailType: $emailType,  
            emailTemplateGuid: $emailTemplateGuid,
            enquiryGuid: $enquiryGuid
      ){
            id,
            fromAddress,
            toAddresses,
            ccAddresses,
            emailType,
            emailStyle,
            emailSubject,
            emailContent,
            files {
                entityType
                guidID
                name
                url
            }
        }
    }
}`;

/* 
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
*/
// const modules = {
//     toolbar: [
//         [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
//         [{size: []}],
//         ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//         [{'list': 'ordered'}, {'list': 'bullet'}, 
//         {'indent': '-1'}, {'indent': '+1'}],
//         ['link', 'image', 'video'],
//         ['clean']
//     ],
//     clipboard: {
//         // toggle to add extra line breaks when pasting HTML:
//         matchVisual: false,
//     }
// };

/* 
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
*/
// const formats = [
//     'header', 'font', 'size',
//     'bold', 'italic', 'underline', 'strike', 'blockquote',
//     'list', 'bullet', 'indent',
//     'link', 'image', 'video'
// ];